export default __webpack_public_path__ + "static/media/Chips.2d72724f.wav";